import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { fileHorsLigne } from '../../horsLigne/fileHorsLigne.js';
import { reserveApi } from '../../api/reserve.js';
import { dansLaPorteeCourante } from '../../api/cles.js';
import { identiteCourante, PorteeObsolete } from '../../auth/identite.js';

export function RejeuScans({ compteId, galerie }: { compteId: string; galerie: string }) {
  const { t } = useTranslation('regie');
  const [refus, setRefus] = useState<string[]>([]);
  useEffect(() => {
    let actif = true;
    async function rejouer() {
      const messages: string[] = [];
      for (const portee of await fileHorsLigne.portees(compteId, galerie)) {
        messages.push(
          ...(await fileHorsLigne.rejouer(portee, (scan) => {
            const identite = identiteCourante();
            if (identite?.compteId !== compteId || identite.galerieSlug !== galerie)
              throw new PorteeObsolete();
            return dansLaPorteeCourante((appel) =>
              reserveApi.scans(galerie, portee.campagneId, [scan], appel),
            );
          })),
        );
      }
      if (actif && messages.length) setRefus((avant) => [...avant, ...messages]);
    }
    const retour = () => void rejouer();
    window.addEventListener('online', retour);
    return () => {
      actif = false;
      window.removeEventListener('online', retour);
    };
  }, [compteId, galerie]);
  return refus.length ? (
    <div role="alert">
      <p>{t('inventaire.scansRefuses')}</p>
      {refus.map((message, i) => (
        <p key={i}>{message}</p>
      ))}
    </div>
  ) : null;
}
